// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/** First segment of a "A · B · C" location, e.g. the site code out of "GA-10 · Mechanical Room". */
export function locationShort(loc: string): string {
  return (loc || '').split('·')[0].trim();
}
